module.exports = __webpack_public_path__ + "media/nav/google-drive-f46c9bc1.png";